module.exports = __webpack_public_path__ + "static/img/xkz.1793278.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/xkz.jpg
// module id = dv5o
// module chunks = 0